/**
 * 设置通用的 菜单数据
 * @param {Vue} Vue
 */
/* eslint-disable */
let install = Vue => {
  if (install.installed) return
  Vue.mixin({
    methods: {
      errorMessage(message) {
        if (!message) {
          message = this.$t('common.requestError')
        }
        this.$message.error(message)
      },
      successMessage(message) {
        if (!message) {
          message = this.$t('common.success')
        }
        this.$message.success(message)
      }
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/cdpBase/mixins/errorMessage.js